import VetHospital from './VetHospital';
export default VetHospital;
